import { render, staticRenderFns } from "./AreaInterna.vue?vue&type=template&id=5f8f445b"
import script from "./AreaInterna.vue?vue&type=script&lang=js"
export * from "./AreaInterna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports